module.exports = __webpack_public_path__ + "static/img/zhuanjie2.a4ba4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zhuanjie2.png
// module id = uPJG
// module chunks = 24